// removed by extract-text-webpack-plugin
module.exports = {"termsList":"_2VyfI"};


//////////////////
// WEBPACK FOOTER
// ../source/static/UserTerms.css
// module id = 535
// module chunks = 1 22